import * as React from 'react'

import {
  Button,
  Modal,
  Space,
  TextBody,
  TextHeading,
  useModalContext,
} from '@ally/metronome-ui'

const headingRef = React.createRef<HTMLHeadingElement>()

const ModalContent: React.FC = () => {
  return (
    <>
      <Space mb="md">
        <TextHeading ref={headingRef} size="md" tabIndex={-1} tag="h1">
          Why we need your Tax ID
        </TextHeading>
      </Space>

      <Space mb="lg">
        <TextBody tag="p" size="md">
          Your Tax ID helps us identify you and ensure that all of your
          information remains safe and secure.
        </TextBody>
      </Space>
    </>
  )
}

const ModalTriggerComponent: React.FC<{ allytmln: string }> = ({
  allytmln,
}) => {
  const { setOpen } = useModalContext()

  return (
    <Button
      allytmln={allytmln}
      onClick={(): void => setOpen(true)}
      text="Why we need your tax ID"
      variant="link"
    />
  )
}

export const WhyTaxIDModal: React.FC<{ allytmln?: string }> = ({
  allytmln = 'whyDoINeedMyTaxID',
}) => (
  <Modal
    content={<ModalContent />}
    trigger={<ModalTriggerComponent allytmln={allytmln} />}
  />
)
